export const wavelyticsQuizPartOne = [
  {
    question: 'What are you currently using for your analytic needs today?',
    id: 0,
    answers: [
      {
        answer: 'Analytics modules inside my CRM',
        id: 0,
      },
      {
        answer: 'BI tool such as Sigma, PowerBI, Tableau, etc',
        id: 1,
      },
      {
        answer: 'Both',
        id: 2,
      },
    ],
  },
  {
    question: 'Do you have internal engineering resources for data management?',
    id: 1,
    answers: [
      {
        answer: 'Yes',
        id: 0,
      },
      {
        answer: 'No',
        id: 1,
      },
    ],
  },
  {
    question: 'What level of customization do you need?',
    id: 2,
    answers: [
      {
        answer: 'Minimal, we prefer out-of-the-box solutions',
        id: 0,
      },
      {
        answer: `Some, we need flexibility but don't want to build from scratch`,
        id: 1,
      },
      {
        answer: 'High, we want full control over our data modeling and outputs',
        id: 2,
      },
    ],
  },
];

export const wavelyticsQuizFullControl = [
  {
    question: 'Do you need to connect and integrate third-party data sources?',
    id: 0,
    answers: [
      {
        answer: 'No, we just need to analyze our data',
        id: 0,
      },
      {
        answer:
          'Yes, we want integration with multiple third-party data sources (ex. Salesforce, Hubspot)',
        id: 1,
      },
    ],
  },
];

export const wavelyticsQuizMinimal = [
  {
    question:
      'How do you or would you like to primarily use data? (Select all that apply)',
    id: 0,
    answers: [
      {
        answer: 'To track and analyze internal operations and efficiencies',
        id: 0,
      },
      {
        answer: 'For internal reporting and visualization',
        id: 1,
      },
      {
        answer:
          'To Compare Performance against industry benchmarks or customer trends',
        id: 2,
      },
    ],
  },
  {
    question: `Do you need and/or want data that compares your company's performance to industry peers?`,
    id: 1,
    answers: [
      {
        answer: 'Yes',
        id: 0,
      },
      {
        answer: 'No',
        id: 1,
      },
    ],
  },
];
